import {Component, OnInit, ViewChild} from '@angular/core';

import {PatientHistoryModel} from './models/patient-history.model';
import {Globals} from '../../globals';
import {PatientService} from '../patient/patient.service';
import {DatePipe, formatDate} from '@angular/common';
import {MedicalHistoryService} from '../../services/form/medical-history.service';
import {FormsService} from '../forms/forms.service';
import {MedicationHistoryModel} from './models/medication-history.model';
import {MedicalHistoryModel} from './models/medical-history.model';
import {NotesService} from '../../services/notes.service';
import {NoteDataModel} from '../../models/notes/note-data.model';
import * as moment from 'moment';
import {PatientDataModel} from '../../models/patient/patient-data.model';
import {PrescriptionListingModel} from '../erx/models';
import {eRxService} from '../erx/erx.service';
import {TdoTableV2Component} from '../../tdo-controls/common/tdo-table-v2/tdo-table-v2.component';

@Component({
  selector: 'app-medical-history',
  templateUrl: './medical-history.component.html',
  styleUrls: ['./medical-history.component.css'],
  providers: [DatePipe]
})
export class MedicalHistoryComponent implements OnInit {
  @ViewChild('prescriptionTable') prescriptionTable: TdoTableV2Component;

  patientHistory: PatientHistoryModel;
  medHistory: MedicationHistoryModel[] = [];
  medicalHistory: MedicalHistoryModel[] = [];
  prescriptions: PrescriptionListingModel[] = [];
  patientName: string = '';
  formData: any;
  patientId: string = '';
  caseWorkItemFormsId: string = '';
  doctorNote: NoteDataModel[] = [];

  isLoading = true;


  patients: PatientDataModel[] = [];

  constructor(public globals: Globals, public patientService: PatientService,
              public medService: MedicalHistoryService, public formService: FormsService,
              public noteService: NotesService, private eRxService: eRxService,
  )
  {
    this.patientId = this.globals.currentPatientId;
    this.getPastRx();

  }

  async ngOnInit() {
    this.getMedHistory();
    this.getPastRx();
  }

  // getPatientInfo(currentPatient) {
  //   const patientBirthday = currentPatient.BirthDate ? moment(currentPatient.BirthDate) : null;
  //   let label = '';
  //   if (patientBirthday) {
  //     label = currentPatient.dataContact.FirstName + ' ' + currentPatient.dataContact.LastName
  //       + ' (' + moment().diff(patientBirthday, 'years') + ')';
  //   } else {
  //     label = currentPatient.dataContact.FirstName + ' ' + currentPatient.dataContact.LastName;
  //   }
  //   this.patientName = label;
  // }

  getMedHistory() {
    this.medService.getMedicalHistory(this.patientId).subscribe( res => {
      console.log(res);
      this.formData = res;
    });
    this.isLoading = false;
  }

  getPastRx() {
    this.eRxService.getPrescriptions(this.globals.currentPatientId).subscribe(
      // tslint:disable-next-line:no-shadowed-variable
      (response: any[]) => {
        this.prescriptions = response.map(o => new PrescriptionListingModel(
          o.RxId,
          o.CaseReference,
          moment(o.RxDate),
          o.DispenseQuantity,
          o.DispenseUnit,
          o.Dosage,
          o.DosageForm,
          o.Medication,
          o.Directions,
          o.Refill,
          o.DoctorID,
          o.DoctorName,
          o.PharmacyID,
          o.PharmacyName,
          o.PharmacyPhoneNumber,
          o.JsonString,
          '',
          o.eRxPharmacyID,
          o.eRxPharmacyName
        ));
        this.prescriptionTable.updateData(this.prescriptions);
        console.log(this.prescriptions);
      },
      error => {
        console.log(error);
      }
    );
  }

  // changePatient(patientId) {
  //   this.patientService.getPatient(patientId).subscribe(res => {
  //     const currentPatient = res.ThePatient;
  //     console.log(res);
  //     this.getPatientInfo(currentPatient);
  //   });
  //   this.patientId = patientId;
  //   this.getMedHistory();
  //   console.log(this.patientName);
  // }

  // getPatients() {
  //   this.patientService.getPatients().subscribe( res => {
  //     this.patients = res;
  //     console.log('patients loaded: ' + this.patients.length);
  //   });
  // }

  getMedHistoryObject() {
    const formData = this.formData;
    for (let i = 0; i < formData.medicationHistoryResults.length; i++) {
      let newMed = {
        resMRXMedication: '',
        resMRXStppedTagingIt: null,
        resMRXLastTaken: null,
        resMRXReason: '',
        resMRXStartDate: null,
        resMRXFrequency: '',
        resMRXQuantity: ''
      };
      // names of meds
      if (formData.medicationHistoryResults[i].ItemName === 'resMRXMedication') {
        newMed.resMRXMedication = formData.medicationHistoryResults[i].Result;
      } else {
        newMed.resMRXMedication = '';
      }
      // quantities
      if (formData.medicationHistoryResults[i].ItemName === 'resMRXQuantity') {
        newMed.resMRXQuantity = formData.medicationHistoryResults[i].Result;
      } else {
        newMed.resMRXQuantity = '';
      }
      // frequencies
      if (formData.medicationHistoryResults[i].ItemName === 'resMRXFrequency') {
        newMed.resMRXFrequency = formData.medicationHistoryResults[i].Result;
      } else {
        newMed.resMRXFrequency = '';
      }
      // reasons
      if (formData.medicationHistoryResults[i].ItemName === 'resMRXReason') {
        newMed.resMRXReason = formData.medicationHistoryResults[i].Result;
      } else {
        newMed.resMRXReason = '';
      }
      // still taking
      if (formData.medicationHistoryResults[i].ItemName === 'resMRXStppedTagingIt') {
        newMed.resMRXStppedTagingIt = formData.medicationHistoryResults[i].Result;
      } else {
        newMed.resMRXStppedTagingIt = null;
      }
      // quantities
      if (formData.medicationHistoryResults[i].ItemName === 'resMRXLastTaken') {
        newMed.resMRXLastTaken = formData.medicationHistoryResults[i].Result;
      }else {
        newMed.resMRXLastTaken = null;
      }
      // quantities
      if (formData.medicationHistoryResults[i].ItemName === 'resMRXStartDate') {
        newMed.resMRXStartDate = formData.medicationHistoryResults[i].Result;
      }else {
        newMed.resMRXStartDate = null;
      }
      this.medHistory.push(newMed);
      console.log(this.medHistory);
    }
  }

}
